var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHomework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#7F91A5",
    d: "M10.819 18.365L6.455 23.82M15.183 18.365l4.364 5.455M22.82 2V1H3.182v17.365"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00234B",
    d: "M25 3l3 3M20.861 13.356L17 14l.644-3.861 8.752-8.753a1.282 1.282 0 0 1 1.834 0l1.384 1.384c.515.515.515 1.32 0 1.834l-8.753 8.752z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7F91A5",
    d: "M22.82 15.482v2.883M1 18.365h24.002M7.546 7.455h8M7.546 12.91h6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomework);
export default __webpack_public_path__ + "static/media/icon-homework.36fc74405b6acb2f1239178f0fc0c3a3.svg";
export { ForwardRef as ReactComponent };